import { useState, useEffect } from 'react';
import {
  DialogContainer,
  DialogTitle,
  DialogBody,
  DialogActions,
} from '../../../common';
import DebtEditHeader from './DebtEditHeader';
import DebtEditTable from './DebtEditTable';
import DebtEditControls from './DebtEditControls';
import DebtEditTotals from './DebtEditTotals';
import { 
  getCurrentDate,
  formatCouponsForUpdate,
} from '../utils/updateDebtUtils';
import { Box } from '@mui/material';

const UpdateDebtEditDialog = ({ 
  open, 
  onClose, 
  onSave, 
  selectedItem, 
  plans 
}) => {
  const [secondExpirationDate, setSecondExpirationDate] = useState(getCurrentDate());
  const [modifiedCoupons, setModifiedCoupons] = useState([]);
  const [payChecks, setPayChecks] = useState([]);
  const [regularizeChecks, setRegularizeChecks] = useState([]);

  useEffect(() => {
    if (selectedItem?.coupons) {
      setPayChecks(selectedItem.coupons.map(() => false));
      setRegularizeChecks(selectedItem.coupons.map(() => false));
      setModifiedCoupons([]);
      setSecondExpirationDate(getCurrentDate());
    }
  }, [selectedItem]);

  const handleModifiedCouponsChange = (newModifiedCoupons) => {
    setModifiedCoupons(newModifiedCoupons);
  };

  const handlePayChecksChange = (newPayChecks) => {
    setPayChecks(newPayChecks);
  };

  const handleRegularizeChecksChange = (newRegularizeChecks) => {
    setRegularizeChecks(newRegularizeChecks);
  };

  const handleSave = () => {
    const formattedData = formatCouponsForUpdate(
      selectedItem.coupons,
      modifiedCoupons,
      payChecks,
      regularizeChecks
    );

    if (formattedData.coupons.length > 0) {
      onSave(formattedData);
      onClose();
    }
  };

  if (!selectedItem) return null;

  return (
    <DialogContainer 
      open={open} 
      onClose={onClose} 
      size="large"
      sx={{
        '& .MuiDialog-paper': {
          maxHeight: '90vh',
          maxWidth: '95vw',
          width: '95vw',
        },
      }}
    >
      <DialogTitle>DEUDAS A LA FECHA</DialogTitle>

      <DialogBody sx={{ 
        p: 0, 
        display: 'flex',
        flexDirection: 'column',
        height: '75vh',
        overflow: 'hidden',
      }}>
        <DebtEditHeader 
          selectedItem={selectedItem}
          plans={plans}
        />

        <DebtEditControls
          secondExpirationDate={secondExpirationDate}
          setSecondExpirationDate={setSecondExpirationDate}
          selectedItem={selectedItem}
          payChecks={payChecks}
          regularizeChecks={regularizeChecks}
          onModifiedCouponsChange={handleModifiedCouponsChange}
          onPayChecksChange={handlePayChecksChange}
          onRegularizeChecksChange={handleRegularizeChecksChange}
        />

        <Box sx={{ 
          flexGrow: 1, 
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
        }}>
          <DebtEditTable
            coupons={selectedItem.coupons}
            modifiedCoupons={modifiedCoupons}
            payChecks={payChecks}
            regularizeChecks={regularizeChecks}
            onModifiedCouponsChange={handleModifiedCouponsChange}
            onPayChecksChange={handlePayChecksChange}
            onRegularizeChecksChange={handleRegularizeChecksChange}
          />
        </Box>

        <DebtEditTotals
          coupons={selectedItem.coupons}
          modifiedCoupons={modifiedCoupons}
          payChecks={payChecks}
          regularizeChecks={regularizeChecks}
        />
      </DialogBody>

      <DialogActions 
        handleClose={onClose} 
        handleSave={handleSave}
      />
    </DialogContainer>
  );
};

export default UpdateDebtEditDialog;